
import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-add-element-classes]';
export const PLUGIN_NAME = 'AddElementClasses';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--add-element-classes" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__add-element-classes/index.js